<template>
  <v-card>
    <v-form ref="form">
      <v-container class="px-6">
        <v-row justify="center">
          <v-col cols="12" class="text-center">
            <v-avatar size="140" class="shadow hover" @click="onImageClick">
              <v-img :src="img || profile.avatar" />
            </v-avatar>
          </v-col>
          <v-col cols="12">
            <input v-show="false" type="file" ref="avatar" @input="onFilePicked" />
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              v-model="crud.first_name"
              :rules="[(v) => !!v || 'Field Required']"
              label="First Name"
              hide-details
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              dense
              label="Last Name"
              :rules="[(v) => !!v || 'Field Required']"
              v-model="crud.last_name"
              hide-details
            />
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn @click="onSave" depressed :loading="loading" color="#FF347C" outlined
              >Save</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
import { patchProfile } from "@/api/api";
export default {
  data() {
    return {
      crud: {
        first_name: this.$store.getters.profile.first_name,
        last_name: this.$store.getters.profile.last_name,
      },
      img: "",
      loading: false,
    };
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    },
  },
  methods: {
    async onSave() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const response = await patchProfile({
        uuid: this.profile.uuid,
        ...this.crud,
      });
      if (response) {
        this.$store.commit("updateProfile", response.data);
      }
      this.loading = false;
    },
    onFilePicked(e) {
      try {
        const [files] = e.target.files;
        if (files !== undefined) {
          const fileName = files.name;
          if (fileName.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener("load", () => {
            this.crud.avatar = files;
            this.img = fr.result;
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    onImageClick() {
      this.$refs.avatar.click();
    },
  },
};
</script>
